"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getBlockForIndex_1 = __importDefault(require("../query/getBlockForIndex"));
const utils_1 = require("../utils");
const getFragmentNode_1 = __importDefault(require("./getFragmentNode"));
const findRangeTarget = (el) => {
    if (el == null) {
        return null;
    }
    else if (['#text', 'BR'].includes(el.nodeName)) {
        return el;
    }
    else if (el.childNodes) {
        const childNodes = Array.from(el.childNodes);
        for (let i = 0; i <= childNodes.length; i++) {
            let child = findRangeTarget(childNodes[i]);
            if (child != null) {
                return child;
            }
        }
    }
    return null;
};
function setDomSelection(editorState, containerNode) {
    const { list } = editorState;
    const { block: focusBlock, blockOffset: focusBlockOffset, } = getBlockForIndex_1.default(list.value, editorState.focusOffset);
    const { block: anchorBlock, blockOffset: anchorBlockOffset, } = getBlockForIndex_1.default(list.value, editorState.anchorOffset);
    if (focusBlock == null || anchorBlock == null) {
        console.warn('cannot select current start and end position');
        return;
    }
    const anchorNodes = containerNode.querySelectorAll(`[data-text-fragment="true"][data-block-key="${anchorBlock.blockKey}"]`);
    const focusNodes = containerNode.querySelectorAll(`[data-text-fragment="true"][data-block-key="${focusBlock.blockKey}"]`);
    let anchorOffset = editorState.anchorOffset - anchorBlockOffset;
    let focusOffset = editorState.focusOffset - focusBlockOffset;
    const anchorFragment = Array.from(anchorNodes).find((node) => {
        return parseInt(node.dataset.fragmentStart) <= anchorOffset &&
            parseInt(node.dataset.fragmentEnd) >= anchorOffset;
    });
    if (anchorFragment == null) {
        return;
    }
    const anchorFragmentOffset = parseInt(anchorFragment.dataset.fragmentStart);
    const focusFragment = Array.from(focusNodes).find((node) => {
        return parseInt(node.dataset.fragmentStart) <= focusOffset &&
            parseInt(node.dataset.fragmentEnd) >= focusOffset;
    });
    if (focusFragment == null) {
        return;
    }
    const focusFragmentOffset = parseInt(focusFragment.dataset.fragmentStart);
    const anchorNode = findRangeTarget(anchorFragment);
    const focusNode = findRangeTarget(focusFragment);
    const newSelection = window.getSelection();
    anchorOffset = anchorOffset - anchorFragmentOffset;
    focusOffset = focusOffset - focusFragmentOffset;
    const fragmentAnchorNode = getFragmentNode_1.default(anchorNode);
    const fragmentFocusNode = getFragmentNode_1.default(focusNode);
    if (fragmentAnchorNode != null && anchorOffset !== 0) {
        anchorOffset = utils_1.getUCS2Position(fragmentAnchorNode.innerText, anchorOffset);
    }
    if (fragmentFocusNode != null && focusOffset !== 0) {
        focusOffset = utils_1.getUCS2Position(fragmentFocusNode.innerText, focusOffset);
    }
    if (newSelection != null && anchorNode != null && focusNode != null) {
        newSelection.setBaseAndExtent(anchorNode, anchorOffset, focusNode, focusOffset);
    }
}
exports.default = setDomSelection;
//# sourceMappingURL=setDomSelection.js.map